import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import InquiryForm from "@/components/InquiryForm";

export default function QuickEnquiry() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="quick-enquiry-tab"
        aria-label="Quick Enquiry"
        className="fixed right-0 top-1/2 -translate-y-1/2 z-50 rounded-l-lg bg-yellow-400 px-2.5 py-5 text-xs font-extrabold uppercase tracking-[0.2em] text-brand-navy shadow-[0_8px_24px_rgba(0,0,0,0.25)] transition-colors hover:bg-yellow-300 [writing-mode:vertical-rl] rotate-180"
      >
        Quick Enquiry
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md rounded-2xl" data-testid="quick-enquiry-dialog">
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl text-brand-navy">Quick Enquiry</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-[#8B89A4] -mt-2 mb-1">Share details & our expert will call you back.</p>
          <InquiryForm compact />
        </DialogContent>
      </Dialog>
    </>
  );
}
